
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/features/new_year",
      function () {
        return require("private-next-pages/phone/features/new_year.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/features/new_year"])
      });
    }
  